import { SelectInput } from "@web-app/components";

export default function MarketCountrySelector({
  onCountryChange,
  selectedCountry,
}: {
  onCountryChange: (countryCode: string) => void;
  selectedCountry: string;
}) {
  return (
    <>
      <div className="flex mb-3 px-4 items-center">
        <div className="text-sm text-gray-900">Select country</div>
        <div className="flex-1 ml-3">
          <SelectInput
            required
            selected={selectedCountry}
            onChange={onCountryChange}
            options={[
              { label: "United States", value: "US" },
              { label: "United Kingdom", value: "GB" },
              { label: "Ireland", value: "IE" },
            ]}
          />
        </div>
      </div>
      <div className="border-t border-gray-200 pt-1"></div>
    </>
  );
}
